module.exports = __webpack_public_path__ + "static/IMG_2373-a12d89e31c61866bfdd4d3edade5fa8f.jpg";